import PropTypes from "prop-types";
import PaymentPriceSummary from "app/pages/.shared/PriceSummary/PaymentPriceSummary";
import { FormattedMessage } from "react-intl";
import PaymentTermsInputContainer from "app/pages/Booking/Payment/PaymentTermsInput/PaymentTermsInputContainer";
import Button, { BUTTON_SIZES, BUTTON_VARIANTS } from "app/pages/.shared/form/Button";
import isEmpty from "lodash/isEmpty";
import Paragraphs from "app/pages/.shared/Paragraphs";
import { useAnalytics } from "app/utils/analytics/useAnalytics";
import { useEffect, useRef } from "react";
import useOnScreen from "app/pages/.shared/useOnScreen";
import { useFormikContext } from "formik";
import FormErrorMessages from "app/pages/.shared/form/FormErrorMessages/FormErrorMessages";
import PaymentButtonLabel from "app/pages/Booking/Payment/PaymentCTASection/PaymentButtonLabel";
import SeparatorLine from "app/components/ui/Separator/SeparatorLine";
import InputFormik from "app/pages/.shared/form/InputFormik";

const PaymentCTASection = ({
	termsField,
	brandDisplayName,
	shouldDisableButton,
	paymentType,
	isOperatorMode,
	cartAmount,
	rgpdMessagePayment,
	onClick,
	onPaymentTermsBlur = () => {},
}) => {
	const { errors, isSubmitting, submitCount } = useFormikContext();

	const { track } = useAnalytics();
	const ref = useRef();
	const isElementOnScreen = useOnScreen({ ref, triggerOnce: false });

	useEffect(() => {
		if (isElementOnScreen) {
			track("payment_view_CTA");
		}
	}, [isElementOnScreen]);

	return (
		<>
			<PaymentPriceSummary />

			<SeparatorLine />

			{Object.keys(errors).includes("terms") && (
				<div className="payment__terms-errors">
					<FormErrorMessages
						errors={errors}
						message={<FormattedMessage id="error.payment.must.accept.terms" />}
						fieldsFilter={["terms"]}
						isSubmitting={isSubmitting}
						submitCount={submitCount}
						disableErrorsDetails={true}
						scrollInToView={false}
					/>
				</div>
			)}

			<div className="payment__terms" ref={ref}>
				<PaymentTermsInputContainer
					onBlur={onPaymentTermsBlur}
					field={termsField}
					brandDisplayName={brandDisplayName}
				/>
			</div>

			{isOperatorMode && (
				<div className="payment__amount-to-pay">
					<InputFormik
						type="number"
						label={
							<span>
								<FormattedMessage id="creditcard.amount.label" />
							</span>
						}
						data-testid="creditcard-amount-input"
						name="payment.card.amount"
						id="creditcard-amount"
					/>
				</div>
			)}

			<Button
				variant={BUTTON_VARIANTS.FILLED}
				size={BUTTON_SIZES.LARGE}
				label={
					<PaymentButtonLabel
						paymentType={paymentType}
						cartAmount={cartAmount}
						isOperatorMode={isOperatorMode}
					/>
				}
				submit
				onClick={onClick}
				loading={shouldDisableButton}
				disabled={shouldDisableButton}
				data-testid="payment-button"
			/>

			{!isEmpty(rgpdMessagePayment) && (
				<div className="payment__personal-data-treatment-label">
					<Paragraphs paragraphs={rgpdMessagePayment} enableHTMLFormatting={true} />
				</div>
			)}
		</>
	);
};

PaymentCTASection.propTypes = {
	termsField: PropTypes.string,
	brandDisplayName: PropTypes.string,
	shouldDisableButton: PropTypes.bool,
	isOperatorMode: PropTypes.bool,
	paymentType: PropTypes.string,
	cartAmount: PropTypes.number,
	rgpdMessagePayment: PropTypes.array,
	onClick: PropTypes.func,
	onPaymentTermsBlur: PropTypes.func,
};

export default PaymentCTASection;
